<template>
 <div class="help-eight-page">
  <div class="b-35-pg8-title" data-langname="outside-bet" />
  <div class="b-35-pg8-table-holder">
    <b-table striped :items="items1" :fields="fields1"></b-table>
    <div class="b-35-pg8-right-holder" >
      <div class="b-35-pg-8-right-text-lower" data-langname="winning-odd-calcualted" />
      <div :class="this.$route.query.lang === 'en' ?  'b-35-outside-bets-formula' : 'b-35-outside-bets-formula-rs'" />
    </div>
  </div>
  <div class="b-35-pg-8-right-text" data-langname="max-per-ticket" />
</div>
</template>

<script>
  export default {
    data() {
      return {
        // Note `isActive` is left out and will not appear in the rendered table
        fields1: [
           {key: 'outside_bet', label: this.$route.query.lang === 'en' ? 'Outside Bet' : 'Dodatno klađenje', class: 'text-center'},
           {key: 'odd', label: this.$route.query.lang === 'en' ? 'Odd' : 'Kvota', class: 'text-center'},
        ],
        items1: [
          { isActive: true, outside_bet: this.$route.query.lang === 'en' ? 'Top Color' : 'Najčešća Boja', odd: '1.90' },
          { isActive: true, outside_bet: this.$route.query.lang === 'en' ? 'First Ball Color' : 'Boja prve kuglice', odd: '1.90' },
          { isActive: true, outside_bet: this.$route.query.lang === 'en' ? 'Last Ball Color' : 'Boja poslednje kuglice', odd: '1.90' },
          { isActive: true, outside_bet: this.$route.query.lang === 'en' ? 'More Odd/Even ' : 'Više neparnih/parnih', odd: '1.90' },
          { isActive: true, outside_bet: this.$route.query.lang === 'en' ? 'Sum of first five more/less 122.5' : 'Suma prvih pet veća/manja od 122.5' , odd: '1.90' },
          { isActive: true, outside_bet: this.$route.query.lang === 'en' ? 'First Ball Odd/Even' : 'Prva kuglica nepar/par', odd: '1.90' },
          { isActive: true, outside_bet: this.$route.query.lang === 'en' ? 'First Ball More/Less 24.5' : 'Prva kuglica veća/manja od 24.5', odd: '1.90' },
          { isActive: true, outside_bet: this.$route.query.lang === 'en' ? 'Last BallOdd/Even' : 'Poslednja kuglica nepar/par', odd: '1.90' },
          { isActive: true, outside_bet: this.$route.query.lang === 'en' ? 'Last BallMore/Less24.5' : 'Poslednja kuglica veća/manja od 24.5', odd: '1.90' }
        ]
      }
    }
  }
</script>